/**
 * @link https://aspireglobal.atlassian.net/wiki/spaces/ASG/pages/143261844/Events
 */
export const FrameworkEventsEnum = {
    CHAT_READY: 'ChatReady',
    DICTIONARY_READY: 'dictionaryReady',
    FW_READY: 'fw_asgReady',
    PLATFORM_READY: 'ngApiReady',
    BALANCE_UPDATED: 'fw_balanceUpdated',
    DEPOSIT_ABORTED: 'fw_depositAborted',
    DEPOSIT_SUCCEEDED: 'fw_depositSucceeded',
    LOGGED_IN: 'fw_LoggedIn',
    LOGGED_OUT: 'fw_LoggedOut',
    PLAYER_POPUP_BANNER: 'fw_playerPopupBanner',
    REGISTRATION_SUCCEEDED: 'fw_registrationSucceeded',
    SHOW_CHAT: 'fw_showChat',
    SEGMENTED_BANNERS_READY: 'ASGSegmentedBannersReady',
    ENGAGE_BANNERS_DATA: 'AspireEngageBannersData',
    BINGO_LOBBY_OPENED: 'fw_bingoLobbyOpened',
    BINGO_ROOM_OPENED: 'fw_bingoRoomOpened',
    BINGO_SOUND_STATE_UPDATED: 'fw_bingoSoundStateUpdated',
};
